<template>
    <div class="input-group">
        <div class="input-icon">
            <i class="fa fa-search fa-fw"></i>
            <input type="text" name="query" v-model="user_search_query" class="form-control" @keydown.enter="toggleSearch">
        </div>
        <span class="input-group-btn">
            <button type="submit" class="btn btn-success" @click="toggleSearch">
                <i class="fa fa-search fa-fw"></i> Zoeken
            </button>
        </span>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Global from '../mixins/Global';

    export default {
        name: 'MenuSearch',

        mixins: [Global],

        data() {
            return {
                user_search_query: '',
            }
        },

        computed: {
            ...mapState([
                'full_screen_search_open'
            ])
        },

        methods: {
            toggleSearch() {
                if (this.user_search_query.length > 0) {
                    let params = new URLSearchParams(location.search);

                    params.set('query', this.user_search_query);

                    if(params.has('order_by')) {
                        params.delete('order_by');
                    }

                    window.history.replaceState({}, '', `${location.pathname}?${params}`);

                    this.$store.commit('toggleFullScreenSearch');
                }
            }
        }
    }
</script>